// extracted by mini-css-extract-plugin
export var subtitle = "saSubtitle-module--subtitle--1mYeY";
export var saSubtitleContainer = "saSubtitle-module--saSubtitleContainer--qiPdZ";